import { configureStore } from "@reduxjs/toolkit";
import generalSliceReducer from "./generalSlice";

export default configureStore({
  reducer: {
    generalSlice: generalSliceReducer,
  },
});
